exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#doc_birthdate{border:1px solid #c4c4c4;border-radius:5px;background-color:#fff;padding:3px 5px;box-shadow:inset 0 3px 6px rgba(0,0,0,.1);width:100%;height:45px;color:#8c9cad}#doc_birthdate ::-moz-placeholder{color:#8c9cad}#doc_birthdate ::placeholder{color:#8c9cad}", ""]);

// exports
